import { useState, useRef, useEffect } from "react";
import { Palette, RotateCcw } from "lucide-react";

const PALETTE = [
  { name: "Pantone 286 C",   fill: "#0033A1", stroke: "#0033A1" },
  { name: "Pantone 7740 C",  fill: "#36843d", stroke: "#36843d" },
  { name: "Pantone 1235 C",  fill: "#fcbb00", stroke: "#b58600" },
  { name: "Pantone 2767 C",  fill: "#13294b", stroke: "#13294b" },
  { name: "Pantone 7701 C",  fill: "#77ddd5", stroke: "#4fb8b0" },
  { name: "Pantone 871 C",   fill: "#8b7849", stroke: "#8b7849" },
  { name: "Pantone 877 C",   fill: "#898a8d", stroke: "#898a8d" },
  { name: "Pantone Black 6", fill: "#101523", stroke: "#101523" },
  { name: "Pantone 7541 C",  fill: "#e0ebe8", stroke: "#a8b5b2" },
  { name: "Pantone 185 C",   fill: "#ea002a", stroke: "#ea002a" },
];

export default function ColorPicker({ currentFill, onSelect, onReset }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={ref} className="relative" onClick={(e) => e.stopPropagation()}>
      <button
        onClick={() => setOpen(o => !o)}
        className="flex-shrink-0 w-4 h-4 rounded-sm border border-white/25 hover:border-white/60 transition-colors"
        style={{ background: currentFill }}
        title="Rengi değiştir"
      />
      {open && (
        <div className="absolute left-0 top-6 z-[2000] bg-[#111726] border border-white/15 rounded-lg p-2 shadow-2xl min-w-[168px]">
          <div className="text-[10px] uppercase font-semibold tracking-wider text-slate-500 mb-1.5 flex items-center gap-1">
            <Palette size={10} /> Renk seç
          </div>
          <div className="grid grid-cols-5 gap-1.5">
            {PALETTE.map(p => (
              <button
                key={p.fill}
                onClick={() => { onSelect(p); setOpen(false); }}
                className={`w-6 h-6 rounded border transition-transform hover:scale-110 ${currentFill === p.fill ? "border-white" : "border-white/20"}`}
                style={{ background: p.fill }}
                title={p.name}
              />
            ))}
          </div>
          <button
            onClick={() => { onReset(); setOpen(false); }}
            className="mt-2 w-full flex items-center justify-center gap-1 text-[10px] uppercase font-semibold py-1 rounded bg-white/5 hover:bg-white/10 text-slate-300"
          >
            <RotateCcw size={10} /> Sıfırla
          </button>
        </div>
      )}
    </div>
  );
}
